<template>
  <!-- 关于 -->
  <div class="aboutPage">
    <!-- 顶部背景图 -->
    <div class="aboutPage-top"></div>

    <!-- 我们是谁 -->
    <div class="introduce">
      <div class="content">
        <div class="title">我们是谁</div>
        <div class="title-line"></div>
        <div class="second-title">产融供应链平台探路者</div>
        <div class="text">
          物润产融供应链平台，是国内领先的以产融供应链、产融科技、产融大数据以及数字产业服务为核心，以“产业+产融供应链+金融”创新模式，
          为客户不断创造价值，以新技术、新服务、新模式“三新”要素，促进产
          融数字化、物流智慧化、平台科技化、品牌高端化“四化”转变，打造长
          江黄金水道首屈一指的“新物流、高智慧、全程可视”的嵌入式智慧物流
          与供应链一站式解决方案，推动我国水路、公路及多式联运向管理智能化、
          运输可视化、流程标准化和运输方式集约化方向发展，引领中国智慧物流
          与供应链转型升级的新路径。
        </div>
      </div>
      <div class="picture"></div>
    </div>

    <!-- 我们的服务，与众不同 -->
    <div class="we-serve">
      <p class="Title">我们的服务，与众不同</p>
      <div class="serve-picture"></div>
    </div>

    <!-- 聚焦产融供应链，为平台用户提供科技服务 -->
    <div class="supply-chain">
      <p class="Title">聚焦产融供应链，为平台用户提供科技服务</p>
      <div class="product">
        <div class="product-item" v-for="(item, i) in list" :key="i">
          <div
            class="icon-bg"
            :style="{ background: `url('${item.bg}') 100% 100% no-repeat` }"
          >
            <img :src="item.icon" alt="" />
          </div>
          <div class="name">{{ item.name }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutPage",
  data() {
    return {
      list: [
        {
          name: "科技",
          content:
            "物流科技+产融科技，旨在帮助客户快速搭建一整套数字化供应链服务体系，提升业务协同效率。",
          bg: require("../../assets/about/bg1.png"),
          icon: require("../../assets/about/icon1.png"),
        },
        {
          name: "数据",
          content:
            "提供分流式数据分析，大幅降低数据分析门槛，无缝对接丰富的数据上下游生态，提升数据分析效率。",
          bg: require("../../assets/about/bg2.png"),
          icon: require("../../assets/about/icon2.png"),
        },
        {
          name: "产品",
          content:
            "为不同供应链业务场景中的应用服务提供平台支持，协助合作伙伴提升供应链服务水平。",
          bg: require("../../assets/about/bg3.png"),
          icon: require("../../assets/about/icon3.png"),
        },
        {
          name: "运营",
          content:
            "提供供应链一站式解决方案，助力产融供应链实现基于大数据技术的精细化运营、提升产品质量和体验。",
          bg: require("../../assets/about/bg4.png"),
          icon: require("../../assets/about/icon4.png"),
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.aboutPage {
  position: relative;
  height: 100%;
  background: #ffffff;

  .aboutPage-top {
    background: url("../../assets/about/banner.png") center center no-repeat;
    height: 662px;
  }
}
// 我们是谁
.introduce {
  width: 1200px;
  height: 440px;
  margin: -80px auto;
  background: #fff;
  border-radius: 9px;
  box-shadow: 0px 21px 58px 1px rgba(0, 0, 0, 0.21);
  display: flex;
  justify-content: center;
  .content {
    width: 600px;
    height: 440px;
    padding: 40px;
    box-sizing: border-box;
    text-align: left;
    .title {
      font-size: 34px;
      color: #000000;
    }
    .title-line {
      width: 60px;
      height: 3px;
      background: #2f82ff;
      margin-top: 27px;
    }
    .second-title {
      font-size: 20px;
      color: #000000;
      line-height: 60px;
    }
    .text {
      color: #666666;
      line-height: 28px;
      font-size: 15px;
    }
  }
  .picture {
    width: 600px;
    height: 440px;
    border-radius: 9px;
    background: url("../../assets/about/picture.png") center center no-repeat;
  }
}
.Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
// 我们的服务
.we-serve {
  margin-top: 140px;
  background: #f5f7fa;
  padding-bottom: 60px;

  .serve-picture {
    height: 778px;
    background: url("../../assets/about/serve.png") center center no-repeat;
  }
}
// 聚焦产融供应链
.supply-chain {
  .product {
    display: flex;
    justify-content: center;
    padding: 10px 0 60px 0;
    .product-item {
      width: 268px;
      height: 354px;
      margin: 0 26px;
      box-shadow: 0px 1px 17px 1px rgba(93, 93, 93, 0.13);
      border-radius: 15px;
      .icon-bg {
        width: 100%;
        height: 102px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .name {
        color: #373d41;
        font-size: 22px;
        text-align: center;
        margin: 45px 0 25px 0;
      }
      .content {
        color: #666666;
        line-height: 28px;
        padding: 0 30px;
        text-align: left;
      }
    }
  }
}
</style>
